import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  margin: 0.5em 0 1.43em;
  display: flex;
  width: 100%;
`;

function InputGroup({ children, ...rest }) {
  return <StyledDiv {...rest}>{children}</StyledDiv>;
}

export default InputGroup;
